// These are currently manually generated but need to look into automatic generation with autorest/ swagger
import { DocumentReviewPeriodEnum } from "shared/enums/document-review-period-enum"
import { DocumentNotifyTypeEnum } from "shared/enums/document-notify-type-enum"
import { DocumentStatusEnum } from "shared/enums/document-status-enum"
import { DocumentModuleEnum } from "shared/enums/document-module-enum"
import { RulebookModeEnum } from 'shared/enums/rulebook-mode-enum';
import { ExemptionFormTypeEnum } from "../../enums/exemption-form-type-enum";
import { EmployeePositionLevelEnum } from "../../enums/employee-level-enum";
import { User } from "../../services/reportingApi";
import { TakeFiveRiskTypeEnum } from "../../enums/take-five-risk-type-enum";
import { IncidentDetailsEnum } from "../../enums/train-event-record-enum";

export interface PagedResult<T> {
    totalResults: number,
    results: T[]
}

export interface IUserSearchResult {
    id: number | null,
    fullname: string,
    email: string,
    city: string,
    officeLocation: string,
    supervisor: string
}

export interface ISortDescriptor {
    field: string,
    dir: string
}

export interface IFilterDescriptor {
    field: string,
    operator: string,
    value: any,
    logic: string
    filters: IFilterDescriptor[]
}

export interface IPageRequest {
    pageSize: number,
    pageNumber: number,
    sort: ISortDescriptor[],
    filter: IFilterDescriptor
}

export interface AdminUserListRequest {

}

export enum EmployeeTypeEnum {
    Unknown = 0,
    System = 1,
    Employee = 2,
    Contractor = 3
}

export enum UserStatusEnum {
    Active = 0,
    Inacitve = 1
}

export interface AdminUserSetStatusRequest {
    status: UserStatusEnum,
    userIds: number[]
}

export interface IRole {
    id: number,
    name: string,
    permissions: string[],
    isBackOfHouseRole: boolean
}

export interface AdminUserModel {
    id: number,
    firstname: string,
    lastname: string,
    fullname: string,
    username: string,
    email: string,
    mobile: string,
    lastLoginDate?: Date,
    password: string,
    employeeType: number,
    companyName: string,
    jobTitle: string,
    roleName: string,
    supervisor?: IUserSearchResult,
    panel: string,
    city: string,
    officeLocation: string,
    department: string,
    division: string,
    status: UserStatusEnum,
    domainDisabled: boolean
}

export enum FatigueAssessmentRiskEnum {
    NA,
    Low,
    Medium,
    High
}

export enum FatigueAssessmentTaskEnum {
    NoAction,
    ToAction,
    ToRevisit
}

export enum FatigueAssessmentStatusEnum {
    Pending,
    Violation,
    Complete
}

export interface FatigueAssessmentForm {
    id: number,
    user?: FatigueAssessmentUser,
    status?: string,
    shiftStartTime?: Date,
    partialShiftStartDate?: string | undefined,
    partialShiftStartTime?: string | undefined,
    dateOfIssue?: Date,
    supervisorId?: number,
    supervisor?: FatigueAssessmentUser,
    issuedBy?: FatigueAssessmentUser,
    onBehalfSubmitter?: FatigueAssessmentUser,
    onBehalfReason?: string,
    assessmentDate?: Date,
    hoursSleep24Hrs?: number,
    hoursSleep48Hrs?: number,
    currentHoursAwake?: number,
    feelAlert?: number,
    alcoholicDrinks?: number,
    gender?: number,
    unfitSubstanceCheck?: number,
    concentrationCheck?: number,
    signOnLocationId?: number,
    signOnLocation?: Location,
    assessmentScore?: number,
    risk?: FatigueAssessmentRiskEnum,
    task?: FatigueAssessmentTaskEnum,
    privacyPolicy?: boolean,
}

export interface FatigueAssessmentNote {
    id: number,
    fatigueAssessmentId: number,
    userId: number,
    userName: string,
    comment: string,
    noteDate: Date
}

export interface FatigueAssessmentAudit {
    id: number,
    fatigueAssessmentId: number,
    date: Date,
    description: string,
}

export interface FatigueAssessmentUser {
    id: number,
    firstname: string,
    lastname: string,
    fullname: string
}

export interface FatigueAssessment {
    id: number
    dateOfIssue: Date
}

export interface FatigueAssessmentActionModel {
    fatigueAssessmentId: number;
    controlsImplementedBy: FatigueAssessmentUser;
    noFurtherAction: boolean;
    actionTaken: boolean;
    actionTakenRevisit: boolean;
    actionTakenBuddyUp: boolean;
    actionTakenRemoveFromSafetyCritical: boolean;
    actionTakenRemainLocal: boolean;
    actionTakenAltDuties: boolean;
    sentHome: boolean;
    comment: string;
    confidential: boolean;
    supervisorSignature: string;
    alternativeSupervisorReason: string;
    affectedSupervisors: FatigueAssessmentUser[];
    noActionTakenPlannedLeave: boolean;
    noActionTakenUnplannedLeave: boolean;
}

export interface FatigueAssessmentDetailsModel extends FatigueAssessmentForm {
    notes: FatigueAssessmentNote[];
    action?: FatigueAssessmentActionModel;
    audit: FatigueAssessmentAudit[];
}

export interface FatigueAssessmentReportQuery {
    userIds: number[];
    supervisorIds: number[];
    locationIds: number[];
    statusIds: FatigueAssessmentStatusEnum[];
    riskIds: FatigueAssessmentRiskEnum[];
    shiftDateFrom: Date;
    shiftDateTo: Date;
    includeAudit: boolean;
}

export interface LoginHistoryReportQuery {
    userIds: number[];
}

export interface LoginHistory {
    loginHistoryResultId: number;
    fullname: string;
    email: string;
    source: string;
    date: string;
}

export interface TakeFiveDashboardQueryModel {
    overview: boolean,
    pending: boolean
    dateRange?: DateRange
}

export interface DashboardQueryModel {
    overview: boolean,
    pending: boolean,
    supervisorIds?: number[],
    date?: Date,
    locationIds?: number[],
    task?: FatigueAssessmentTaskEnum
}

export interface SubmitActionModel {
    fatigueAssessmentId?: number;
    controlsImplementedById?: number;
    noFurtherAction?: boolean;
    noActionTakenPlannedLeave?: boolean,
    noActionTakenUnplannedLeave?: boolean,
    actionTaken?: boolean;
    actionTakenRevisit?: boolean;
    actionTakenBuddyUp?: boolean;
    actionTakenRemoveFromSafetyCritical?: boolean;
    actionTakenRemainLocal?: boolean;
    actionTakenAltDuties?: boolean;
    sentHome?: boolean;
    comment?: string;
    confidential?: boolean;
    supervisorSignature?: string;
    alternativeSupervisorReason?: string;
    affectedSupervisors: number[];
}

export interface SubmitAssessmentModelBase {
    id?: number,
    hoursSleep24Hrs: number,
    hoursSleep48Hrs: number,
    currentHoursAwake: number,
    supervisorId: number,
    signOnLocationId: number,
    shiftStartTime: Date,
    privacyPolicy: boolean,    
    priorSleepWakeScore: number
}

export interface SubmitAssessmentModel extends SubmitAssessmentModelBase {
    feelAlert: number,
    alcoholicDrinks: number,
    gender: number,
    unfitSubstanceCheck: number,
    concentrationCheck: number
}

export interface SubmitOnBehalfModel extends SubmitAssessmentModel {
    userId: number;
    onBehalfReason: string;
    action: SubmitActionModel;
}

export interface FatigueAssessmentAddNoteModel {
    fatigueAssessmentId: number,
    comment: string
}

export interface FatigueAssessmentAssign {
    userIds: number[],
    shiftStartTime: Date
}

export interface FatigueAssessmentAssignResult {
    time: Date;
    added: number;
    existing: number;
    failed: number;
}

export interface Metadata {
    id: number;
    documentId: number;
    createdDate: Date;
    documentNumber: string;
    version: string;
    title: string;
    publishDate: Date;
    effectiveFromDate: Date;
    expiryDate?: any;
    reviewPeriod: DocumentReviewPeriodEnum,
    reviewRecurring: boolean,
    notifyUsers: boolean;
    releaseNotes: string;
    rescindDocumentReason: string;
    requiresAcknowledgement: boolean;
    active: boolean;
    rescindedById?: any;
    rescindedBy?: any;
    rescindedDate?: any;
    deletedById?: any;
    deletedBy?: any;
    deletedDate?: any;
    modifiedById: number;
    modifiedBy?: any;
    modifiedDate: Date;
    department?: string
}

interface RelatedDocument {
    id: number,
    title: string
}


export interface RailDocument {
    id: number;
    fileName: string;
    uploadedById: number;
    uploadedByName: string;
    uploadedDate: Date;
    moduleId: DocumentModuleEnum;
    module: string;
    typeId: number;
    type: string;
    subTypeId: number;
    subType: string;
    status: DocumentStatusEnum;
    statusDescription: string;
    createdDate: Date;
    documentNumber: string;
    version: string;
    title: string;
    publishDate: Date;
    effectiveFromDate: Date;
    expiryDate?: any;
    reviewPeriod: DocumentReviewPeriodEnum,
    reviewRecurring: boolean,
    releaseNotes: string;
    rescindDocumentReason: string;
    active: boolean;
    rescindedById?: any;
    rescindedByName?: any;
    rescindedDate?: any;
    deletedById?: any;
    deletedByName?: any;
    deletedDate?: any;
    modifiedById: number;
    modifiedByName: string;
    modifiedDate: Date;
    requiresAcknowledgementAndNotify: boolean;
    relatesTo?: Array<{ key: number, value: string }>;
    canEdit?: boolean;
    acknowledgeRequired?: boolean;
    pendingActions?: RailDocumentPendingActions,
    isFavourite?: boolean,
    cbtc?: boolean,
    traditional?: boolean,
    departments?: DocumentDepartmentModel[],
    departmentNames?: string[],
    document?: string,
    department?: string,
    documentTeams?: DocumentTeamModel[],
    documentUsers?: User[]
}

export interface DocumentDepartmentModel {
    id?: number,
    name?: string,
    documentId?: number
}

export interface DocumentTeamModel {
    id?: number,
    team?: string,
    documentId?: number
}

export interface DocumentType {
    id: number;
    parentTypeId?: number | null;
    name: string;
    documentModuleId: number;
    documentTitleDefault: string;
    documentTitleValidation: string;
    documentNumberDefault: string;
    documentNumberValidation: string;
}

export interface DocumentDepartment {
    id: number;
    name: string;
}


export interface NewDocument {
    documentModule?: number,
    documentType?: number,
    title?: string,
    documentNumber?: string,
    versionNumber?: string,
    effectiveFrom: string,
    expiryDate?: string,
    reviewPeriod: DocumentReviewPeriodEnum,
    reviewRecurring: boolean,
    requiresAcknowledgementAndNotify?: boolean,
    releaseNotes?: string,
    rescindDocumentReason?: string,
    file?: File,
    relatesTo: Array<number>,
    rulebookOperatingSystem?: RulebookModeEnum,
    departments?: number[],
    department?: string,
    departmentTeams?: string[],
    personnelId?: number[]
}

export interface UserInfo {
    role?: string[]
}

export interface DocumentHistory {
    id: number,
    version?: string,
    actionId: number,
    action: string,
    rescindedByDocumentNumber?: string,
    rescindedByDocumentId?: number,
    rescindsDocumentNumber?: string,
    rescindsDocumentId?: number,
    releaseNotes?: string,
    userId?: string,
    userName?: string,
    changeDate: Date,
    statusId: number,
    status: string,
    d2ChangeDate: Date
}

export interface Notifications {
    fatigueAssessments: [FatigueAssessment],
    documentNotifications: [DocumentNotification],
}

export interface DocumentNotification {
    id: number,
    userId: number,
    userName: string,
    documentId: number,
    documentTitle: string,
    documentNumber: string,
    documentType: number,
    documentPublishDate: Date,
    notifyDate: Date,
    notifyType: DocumentNotifyTypeEnum,
    acknowledgedDate?: Date,
}

export interface RailDocumentPendingActions {
    documentId: number,
    acknowledge: boolean
    clarify: boolean
    feedback: boolean,
    view: boolean,
    latestAction?: string,
    latestActionDate?: Date,
    acknowledgedDate?: Date
}

export interface DocumentComment {
    text: string
}

export interface DocumentSearchQuery {
    searchTerm: string,
    statusIds?: number[],
    moduleIds?: number[],
    typeIds?: number[],
    dateRange?: DateRange,
    fullMatchContentRequired?: boolean,
    mode?: string
}

export interface DateRange {
    startDate: Date,
    endDate: Date
}

export interface DocumentSearchResult {
    documentId: number,
    moduleId: number,
    typeId: number,
    documentTitle: string,
    documentNumber: string,
    publishedDate: Date,
    version: string,
    status: DocumentStatusEnum,
    pageNumber: number,
    matchText: string,
    matchContent?: DocumentContent[],
    totalResults: number,
    requiresAcknowledgement: boolean,
    favourite: boolean
}

export interface DocumentSearchReplaceSuggestion {
    id: number;
    expression: string;
    suggestion: string;
}

export interface DocumentContent {
    id: number,
    documentId: number,
    content?: string,
    pageNumber: number
}

export interface Location {
    id: number,
    name: string
}

export interface LocationDetail extends Location {
    siteMobileNumber: string
}

export interface AbmCodeUsage {
    available: number;
    used: number;
}

export interface AddCodeResult {
    added: number;
    duplicate: number;
    invalid: number;
    error?: string;
}

export interface DrivingExemptionForm {
    id: number,
    drivingExemptionFormType?: ExemptionFormTypeEnum,
    positionLevel?: EmployeePositionLevelEnum,
    reportToEmail?: string,
    deptManagerId?: number,
    bhpOwnedOrHiredLV?: string,
    monitoringSystemInstalled?: string,
    hiredLVMonitoringSysInstallationArrangements?: string,
    lvAssetName?: string,
    lvRegistrationNumber?: string,
    drivingExemptionJustification?: string,
    hoursOfDriving?: string,
    requiredToAttendSiteoutsideOfNormalBusiness?: boolean,
    lvCommuteTermsAcknowledgement?: boolean,
    gnhTermsAcknowledgement?: boolean,
    dssInstalled?: number,
    startDate?: Date,
    endDate?: Date,
    twelveMonthsExemption?: boolean,
    onBehalfUser?: number,
    user?: FatigueAssessmentUser,
    lVTravelShift?: string
}

export interface SubmitDrivingExemptionModel {
    drivingExemptionFormType?: ExemptionFormTypeEnum,
    positionLevel?: EmployeePositionLevelEnum,
    reportToEmail?: string,
    deptManagerId?: number,
    bhpOwnedOrHiredLV?: string,
    monitoringSystemInstalled?: number,
    hiredLVMonitoringSysInstallationArrangements?: string,
    lvAssetName?: string,
    lvRegistrationNumber?: string,
    drivingExemptionJustification?: string,
    hoursOfDriving?: string,
    requiredToAttendSiteoutsideOfNormalBusiness?: number,
    termsAcknowledgement?: boolean,
    dssInstalled?: number,
    startDate?: Date,
    endDate?: Date,
    twelveMonthsExemption?: number,
    lVTravelShift?: string
}
export interface SubmitOnBehalfDrivingExemptionModel extends SubmitDrivingExemptionModel {
    userId: number;
    onBehalfReason: string;
}
export interface DepartmentManager {
    id: number,
    firstName: string,
    lastName: string,
    email: string,
    departmentName?: string
}

export interface UserSupervisor {
    name?: string,
    email: string
}

export enum DrivingExemptionStatusEnum {
    Requested,
    InitialReviewApproved,
    DeptManagerApproved,
    GMApproved,
    Expired,
    InitialReviewRejected,
    DeptManagerRejected,
    GMRejected,
    Approved,
    InitialReviewCancelled,
    FinalReviewCancelled,
}

export interface GNHExemptionReportQuery {
    userIds: number[];
    supervisorIds: number[];
    statusIds: DrivingExemptionStatusEnum[];
    requestDateFrom: Date;
    requestDateTo: Date;
    includeAudit: boolean;
}

export interface DrivingExemptionAudit {
    id: number,
    drivingExemptionId: number,
    status: DrivingExemptionStatusEnum,
    updateComment:string,
    actionedBy:string,
    updateDate: Date
}

export interface UserDrivingExemptionList {
    id: number,
    user: FatigueAssessmentUser,
    status: DrivingExemptionStatusEnum,
    requestDate: Date,
    updateDate: Date,
    actionedBy: string,
    comment: string,
    startDate: Date,
    endDate: Date,
    formTypeEnum: ExemptionFormTypeEnum,
    exemptionHistory: DrivingExemptionAudit[],
    submittedOnBehalf: boolean
}

export interface NewTaskTakeFive {
    Id?: number,
    locationId?: number,
    otherLocation?: string,
    taskName?: string,
    taskScopeUnderstood?: number,
    procedureExist?: number,
    taskStepsUnderstood?: number,
    areToolsAndEquipmentsInGoodOrder?: number,
    correctPPE?: number,
    necessaryPermits?: number,
    clearPlan?: number,
    canRiskToHandsBeEliminated?: number,
    handsPlacedInVicinity?: number,
    equipmentGuardseRemoved?: number,
    mobileEquipmentRisk?: number,
    areHazardousMaterialsInvloved?: number,
    taskPerformedWithoutIsolationProcedure?: number,
    workingAtHeights?: number,
    impactedByOtherActivity?: number,
    environmentalHnSHazards?: number,
    riskLevelEqualOrGreaterThanH11?: boolean, // changed from number
    taskHazards?: Hazard[]
    //remove the below if possible
    hazard?: number,
    otherHazard?: string,
    riskType?: number,
    risk?: number,
    control?: string,
    score?: string,
    file?: File,
    bGroundColor?: string,
    riskTag?: string,
    riskAssessmentMatrix?: RiskAssessmentMatrix[],
    hazardLookup?: HazardLookup[],
    riskLookup?: RiskLookup[],
    locationLookup?: LocationDetail[],
    uri?: string,
    fileName?: string
}

export interface HazardImage {
    file?: File,
    fileName?: string
}

export interface TaskTakeFiveModel {
    id?: number
    locationId?: number,
    locationName?: string,
    otherLocation?: string,
    taskName?: string,
    taskScopeUnderstood?: number,
    procedureExist?: number,
    taskStepsUnderstood?: number,
    areToolsAndEquipmentsInGoodOrder?: number,
    correctPPE?: number,
    necessaryPermits?: number,
    clearPlan?: number,
    canRiskToHandsBeEliminated?: number,
    handsPlacedInVicinity?: number,
    equipmentGuardseRemoved?: number,
    mobileEquipmentRisk?: number,
    areHazardousMaterialsInvloved?: number,
    taskPerformedWithoutIsolationProcedure?: number,
    workingAtHeights?: number,
    impactedByOtherActivity?: number,
    environmentalHnSHazards?: number,
    riskLevelEqualOrGreaterThanH11?: boolean,
    dateCreated: Date,
    taskHazards?: Hazard[],
    createdBy?: string
    location?: string
}

export interface Hazard {
    id?: number,
    hazardId?: number,
    hazardDetail?: string,
    otherHazard?: string,
    riskType: number,
    riskId: number,
    riskDetail?: string,
    control: string,
    riskScore?: number,
    file?: File,
    imageFileName?: string,
    bGroundColor?: string,
    riskTag?: string,
}

export interface HazardLookup {
    id: number,
    hazard: string,
    hazardNumber: string
}

export interface RiskLookup {
    id: number,
    type: TakeFiveRiskTypeEnum,
    risk: string
}

export interface RiskAssessmentMatrix {
    id: number,
    likelyhood: number,
    consequency: number,
    score: number,
    tag: number,
    color: string,
    description: string,
    dateCreated: Date,
    modifiedDate: Date
}

export enum TakeFiveRiskEnum {
    Low = 0,
    High = 1
}

export interface TrainEventRecordModel {
    id?: number,
    trainSerialNumber?: string,
    eventDate?: any,
    eventTime?: string,
    durationOfDelay?: string,
    driverName?: FatigueAssessmentUser,
    driversDepot?: number,
    driversId?: number,
    leadLoco?: boolean,
    remoteLoco?: boolean,
    trailLocoB?: boolean,
    trailLocoA?: boolean,
    brakeType?: string[],
    leaderActive?: boolean,
    eotNo?: number,
    line?: number,
    kmPeg?: boolean,
    isLoaded?: number,
    weatherConditions?: string,
    supervisorName?: FatigueAssessmentUser,
    percentageOperable?: number,
    //Incident Details
    incident?: string[],
    result?: string[],
    radioFaultType?: string[],
    sequenceOfEvents?: string,
    incidentType?: string,
    faultKmStart?: string,
    faultKmEnd?: string,
    handhelSerialNo?: string,
    noOfBp?: number,
    noOfRes?: number,
    noOfBc?: number,
    TrainECPBModelList?: TrainECPBModel[],
}

export interface SubmitTrainEventRecordModel {
    id: number,
    trainSerialNumber?: string,
    eventDate?: Date,
    eventTime?: string,
    durationOfDelay?: string,
    driverName?: FatigueAssessmentUser,
    driversDepot?: number,
    driversId?: number,
    leadLoco?: boolean,
    remoteLoco?: boolean,
    trailLocoB?: boolean,
    trailLocoA?: boolean,
    brakeTypeId?: string,
    brakeType?: string[],
    leaderActive?: boolean,
    eotNo?: number,
    line?: number,
    kmPeg?: boolean,
    isLoaded?: number,
    weatherConditions?: string,
    supervisorId?: number,
    percentageOperable?: number,
    supervisorName?: FatigueAssessmentUser,
    TrainIncidentDetails: TrainIncidentDetailsModel,
    TrainECPBModelList: TrainECPBModel[],
}

export interface TrainIncidentDetailsModel {
    incidentType?: string,
    result?: string,
    sequenceOfEvents?: string,
    radioFault?: string,
    faultKmStart?: string,
    faultKmEnd?: string,
    handhelSerialNo?: string,
}

export interface TrainECPBModel {
    bPPressure?: number,
    rESPressure?: number,
    bCPressure?: number,
}

export interface TakeFiveReportQuery {
    userIds: number[];
    supervisorIds: number[];
    riskLevels: TakeFiveRiskEnum[];
    requestDateFrom: Date;
    requestDateTo: Date;
    includeHazards: boolean;
}
export interface TrainEventRecordReportQuery {
    userIds: number[];
    supervisorIds: number[];
    IncidentDetailsId: IncidentDetailsEnum[];
    requestDateFrom: Date;
    requestDateTo: Date;
}

export interface TrainEventRecordList {
    id: number,
    driversName: FatigueAssessmentUser,
    supervisor: FatigueAssessmentUser,
    eventDate: Date,
    leaderActive?: boolean,
    isLoaded?: boolean,
    driversDepotName: string,
    durationOfDelay?: string,
}

// ---------------------------------------------------------------------------
// User Approvals
// Models for the User Approvals dashboard (pending user access requests that a
// contract manager approves). Mirrors the shapes used by the Fatigue Assessment
// dashboard (list items + a query model + a status enum).
// ---------------------------------------------------------------------------

export enum UserApprovalStatusEnum {
    Pending,
    Approved,
    Rejected,
    Inactive
}

export interface UserApprovalItem {
    // Identity user id (GUID string).
    id: string,
    // The person requesting access.
    name: string,
    user?: IUserSearchResult,
    // The BHP contract manager responsible for approving this request.
    contractManagerId?: number | null,
    contractManagerName: string,
    status: UserApprovalStatusEnum,
    dateRequested: Date,
    emailDomain?: string,
    company?: string
}

export interface UserApprovalQueryModel {
    // When true, only return the currently logged-in manager's action items.
    // When false, return all action items.
    onlyMine: boolean,
    // Account states to include. When empty/undefined, all states are returned.
    statuses?: UserApprovalStatusEnum[]
}

export interface UserApprovalResult {
    id: string,
    status: UserApprovalStatusEnum
}
